'use client';

import { useCallback, type ReactNode } from 'react';

interface EmailLinkProps {
  name: string; // e.g., "info", "privacy", "service"
  domain?: string; // defaults to "valbewust.nl"
  className?: string;
  children?: ReactNode; // If not provided, shows the email address
}

/**
 * Bot-proof email link component.
 * Email is constructed via JavaScript on click, not visible in HTML source.
 */
export function EmailLink({ name, domain = 'valbewust.nl', className, children }: EmailLinkProps) {
  const handleClick = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    const email = `${name}@${domain}`;
    window.location.href = `mailto:${email}`;
  }, [name, domain]);

  // Construct display text - only shown after JS execution for extra protection
  const displayEmail = `${name}@${domain}`;

  return (
    <a
      href="#"
      onClick={handleClick}
      className={className}
      data-n={name}
      data-d={domain}
    >
      {children || displayEmail}
    </a>
  );
}
